/** @returns {string} pathname + query + hash for GTM `page_path` */
export function getGtmPagePath() {
  const { pathname, search, hash } = window.location;
  return `${pathname}${search}${hash}`;
}

/** Push a custom event into `dataLayer` for GA4 via GTM */
export function pushToDataLayer(event, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}
